<!--
Based on https://github.com/Code-Pop/real-world-vue/blob/master/src/components/BaseButton.vue

Uses dynamic <component :is> to use <a> for <EsButton href="">
https://vuejs.org/v2/guide/components.html#Dynamic-Components
Based on last example at: https://www.codegram.com/blog/create-a-reusable-button-with-vue-dynamic-components/
-->
<template>
    <component
        :is="href ? 'a' : 'button'"
        :href="href"
        v-bind="$attrs"
        class="btn"
        :class="buttonClass"
        v-on="$listeners"
    >
        <slot />
    </component>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        buttonClass: {
            type: [String, Object],
            default: 'btn-primary',
        },
        href: {
            type: String,
            required: false,
            default: null,
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/sass/bs4/_variables.scss";

.btn-primary {
    box-shadow: 0 0 0 1px transparent,$btn-primary-box-shadow;

    &:hover, &:focus, &:active {
        background-color: $blue-700;
        border-color: $blue-700;
    }
    &:focus {
        border-color: $blue-100;
        box-shadow: 0 0 0 1px $blue-100,$btn-primary-box-shadow;
    }
    &:active {
        background-color: $blue-800;
        border-color: $blue-800;
        box-shadow: 0 0 0 1px transparent,$btn-primary-active-box-shadow;
        transform: $btn-active-transform;
    }
}

.btn-outline-primary {
    box-shadow: 0 0 0 1px transparent,$btn-primary-box-shadow;

    &:hover, &:focus, &:active {
        background-color: $blue-50 !important;
        border-color: $blue-600 !important;
        color: $blue-600 !important;
    }

    &:focus {
        box-shadow: 0 0 0 1px $blue-600,$btn-primary-box-shadow;
    }

    &:active {
        background-color: $blue-200 !important;
        box-shadow: 0 0 0 1px transparent,$btn-primary-active-box-shadow;
        transform: $btn-active-transform;
    }
}
</style>
